export const environment = {
  production: false,
  frontUrl: 'https://api-test.facturacion-idmhperu.website/',
  apiUrl: 'https://api-test.facturacion-idmhperu.website/api',
  recaptchaSiteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
};

/**

export const environment = {
  production: false,
  frontUrl: 'http://localhost:4200/',
  apiUrl: 'http://localhost:8090/api',
};

export const environment = {
  production: true,
  frontUrl: 'https://api.facturacion-idmhperu.website/',
  apiUrl: 'https://api.facturacion-idmhperu.website/api',
};

 */